<template>
  <v-row justify="center">
    <v-dialog
        v-model="showDialog"
        persistent
        max-width="600"
    >
      <v-card>
        <div class="d-flex align-center py-2">
          <v-card-title class="headline mr-auto">
            ¿Está de seguro de cancelar la Orden de Pago ?
          </v-card-title>
          <v-btn class="mr-4" fab small text @click="onCloseDialog()">
            <v-icon>fas fa-times</v-icon>
          </v-btn>
        </div>
        <v-divider class="mx-4"></v-divider>
        <v-card-text>
          <v-radio-group v-model="deleteAction">
            <v-radio
                class="py-1"
                label="Cancelar orden de pago con todos los trámites."
                value="1"
            ></v-radio>
            <v-radio
                class="py-1"
                label="Cancelar la orden de pago y conservar trámites al portafolio."
                value="0"
            ></v-radio>
          </v-radio-group>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="normal"
              @click="onCloseDialog()"
          >
            Cerrar
          </v-btn>
          <v-btn
              color="error"
              @click="onConfirmDelete(deleteAction)"
          >
            Cancelar Orden
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
    export default {
        name: "DeleteDialog",
        props: ['showDialog', 'onConfirmDelete', 'onCloseDialog'],
        data(){
            return {
                deleteAction: '0'
            }
        },

        methods: {

        }
    }
</script>

<style scoped>

</style>